export enum UserRole {
  SELLER = 'seller',
  MANAGER = 'manager',
}
